import React from 'react';
import { IAvailableAssetTypes } from '@brickwise/asset-validation/dist/utils';

export const AssetTypeContext = React.createContext({
  assetType: 'realEstate' as IAvailableAssetTypes,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setAssetType: (newType: IAvailableAssetTypes) => {},
});

export const useAssetType = () => React.useContext(AssetTypeContext);
